import "./styles.scss";

import { createApp } from "vue";
import { QueryClient, VueQueryPlugin } from "@tanstack/vue-query";
import UserManagement from "./UserManagement.vue";
import { initApiUrl } from "./api.js";

$(document).ready(function () {
	if (!/\/application\/user$/.test(window.location.pathname)) {
		return;
	}

	const container = $("#vue-container");
	if (!container.length) {
		return;
	}

	const userApiUrl = container.data("userApiUrl");
	if (!userApiUrl) {
		console.error("Missing required userApiUrl for user management");
		return;
	}
	initApiUrl(userApiUrl);

	const app = createApp(UserManagement);

	const queryClient = new QueryClient({
		defaultOptions: {
			queries: {
				staleTime: 1000 * 30,
				gcTime: 1000 * 60 * 10,
				retry: 2,
			},
		},
	});
	app.use(VueQueryPlugin, { queryClient });

	app.mount(container[0]);
});
